/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Execute_Detail7Inputs */

const en_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core functionality first, popup/UI polish second, cross-browser tested.`)
};

const ar_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوظيفة الأساسية أولًا وصقل المنبثقة/الواجهة ثانيًا واختبار عبر المتصفحات.`)
};

const bn_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আগে কোর ফাংশনালিটি, পরে পপআপ/UI পলিশ, ক্রস-ব্রাউজার টেস্টেড।`)
};

const de_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuerst die Kernfunktionalität, dann Popup/UI-Feinschliff, browserübergreifend getestet.`)
};

const es_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primero la funcionalidad principal, luego el pulido de ventanas emergentes/UI, probado en varios navegadores.`)
};

const fr_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalité de base en premier, peaufinage des popups et de l'interface utilisateur en second lieu, testé sur plusieurs navigateurs.`)
};

const pt_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funcionalidade principal primeiro, pop-up/IU em segundo lugar, testado em vários navegadores.`)
};

const zh_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首先是核心功能，其次是弹出窗口/UI 完善，跨浏览器测试。`)
};

const tr_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önce temel işlevsellik, ikinci olarak açılır pencere/kullanıcı arayüzü iyileştirmesi, tarayıcılar arası test edildi.`)
};

const ru_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сначала основная функциональность, затем доработка всплывающих окон и пользовательского интерфейса, кросс-браузерное тестирование.`)
};

const pl_svc_browser_extensions_execute_detail7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpierw funkcjonalność podstawowa, następnie dopracowanie wyskakujących okienek/interfejsu, przetestowano w różnych przeglądarkach.`)
};

/**
* | output |
* | --- |
* | "Core functionality first, popup/UI polish second, cross-browser tested." |
*
* @param {Svc_Browser_Extensions_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_execute_detail7 = /** @type {((inputs?: Svc_Browser_Extensions_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_execute_detail7(inputs)
	if (locale === "de") return de_svc_browser_extensions_execute_detail7(inputs)
	if (locale === "es") return es_svc_browser_extensions_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_execute_detail7(inputs)
	return en_svc_browser_extensions_execute_detail7(inputs)
});
export { svc_browser_extensions_execute_detail7 as "svc_browser-extensions_EXECUTE_detail" }